let Promise = require('bluebird');
let agent = require('superagent');
let $ = require('jquery');
let modal = require('./modal');
let globalChaos = require('./global-chaos');
let {url} = require('../utils');

let $loading = $('#global-loading');
let $silentLoading = $('.global-silent-loading');

let template = require('templates/double-password-request.hbs');

class RequestError extends Error {

}

class Request {
    constructor() {
        this.isSilent = false;
        this.isBlocked = false;
        this.isBackground = false;
        this.$blockedContainer = null;
        this.el = null;
        this.files = {};
        this.formData = null;
    }

    background() {
        this.isBackground = true;
        return this;
    }

    block($container) {
        this.$blockedContainer = $($container)

        this.$blockedContainer
            .removeClass('blockable')
            .addClass('blockable')
            .addClass('blocked');
        this.isBlocked = true;

        return this;
    }

    silent(value = true) {
        this.isSilent = value;
        return this;
    }

    showShoutMessage(message) {
        if (this.isBackground) return;

        $loading
            .removeClass('is-not-loading')
            .addClass('is-loading')
            .find('.message')
            .html(message || 'Carregando...');
        return this;
    }

    hideShoutMessage(message) {
        if (this.isBackground) return;

        $loading
            .removeClass('is-loading')
            .addClass('is-not-loading');
    }

    showSilentMessage(message) {
        if (this.isBackground) return;

        this.el = $silentLoading
            .clone();

        $('body')
            .append(this.el);

        this.el
            .addClass('is-loading')
            .find('.message')
            .html(message || 'Carregando...');
    }

    hideSilentMessage() {
        if (this.isBackground) return;

        setTimeout(() => {
            this.el
                .removeClass('is-loading')
                .addClass('is-not-loading');
        }, 1000);

        setTimeout(() => {
            this.el.remove();
        }, 5000)
    }

    showMessage(message) {
        if (this.isBackground) return;

        if (this.isSilent) {
            this.showSilentMessage(message);
        } else {
            this.showShoutMessage(message);
        }
    }

    hideMessage() {
        if (this.isBlocked) {
            this.$blockedContainer.removeClass('blocked');
        }

        if (this.isBackground) return;

        if (this.isSilent) {
            this.hideSilentMessage();
        } else {
            this.hideShoutMessage();
        }
    }


    execute(message, instance) {
        this.showMessage(message);

        return new Promise((resolve, reject) => {
            instance.set('Accept', 'application/json');

            instance.end((err, response) => {
                // esse timeout serve para eyecandy da tela de loading
                setTimeout(() => {
                    this.hideMessage();
                }, 600);

                if (err) {
                    err.hiddenError = true;
                    return reject(err, response.body);
                }

                return resolve(response.body);
            })
        })
    }

    secureExecute(message, instance) {
        return new Promise((resolve, reject) => {
            let submitRequest = ($modal, fn = null) => {
                let password = $modal.find('[name=password]').val();

                instance.set('XDoublePassword', password);

                resolve(this
                    .execute(message, instance)
                    .catch(globalChaos)
                    .then(globalChaos)
                    .finally((data) => {
                        fn && fn(data);
                        return data;
                    }));
            };

            let $modal = modal({
                title: `<i class="fa fa-lock"></i> Para completar essa ação você precisa redigitar sua senha.`,
                body: template({}),
                secondaryButton: `Cancelar`,
                primaryButton: `Excluir registro definitivamente`,
                primaryButtonClass: 'red',
                width: 600,
                onShown: function ($modal) {
                    $modal.find('.form-control')
                        .first()
                        .focus();
                },
                onPrimaryButton: function ($modal, close) {
                    submitRequest($modal, close);
                }
            });

            $modal.find('form').submit(function () {
                submitRequest($modal, () => {
                    $modal.trigger('modal.close');
                });
                return false;
            });
        });
    }

    get(message, path, params) {
        return this.execute(message, agent.get(url(path)).query(params));
    }

    post(message, path, data) {
        return this.execute(message, agent.post(url(path)).send(data));
    }

    put(message, path, data) {
        return this.execute(message, agent.put(url(path)).send(data));
    }

    delete(message, path, data) {
        return this.execute(message, agent.del(url(path)).send(data));
    }

    secureDelete(message, path) {
        return this.secureExecute(message, agent.del(url(path)));
    }

    attach(key, file) {
        this.files[key] = file;
        return this;
    }
}

Request.get = (message, path, params) => {
    return new Request()
        .get(message, path, params);
};

Request.post = (message, path, data) => {
    return new Request()
        .post(message, path, data);
};

Request.put = (message, path, data) => {
    return new Request()
        .put(message, path, data);
};

Request.delete = (message, path) => {
    return new Request()
        .delete(message, path);
};

Request.secureDelete = (message, path) => {
    return new Request()
        .secureDelete(message, path);
};

Request.silent = (value = true) => {
    return new Request()
        .silent(value);
};

Request.background = (value = true) => {
    return new Request()
        .background(value);
};

module.exports = Request;



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/request.js